import { renderTemplate } from '../../util/markdownTemplate';
import { useLingui } from '@lingui/react';
import { useContext, useMemo, useRef } from 'react';
import { useJnx } from '../../util/jnx';
import { useSideChannelSubscription } from '../../util/useSideChannel';
import UWEFormContext from '../../context/UWEFormContext';
import Markdown from 'react-markdown';
import { Label } from 'src/components/ui';
import { UncontrolledTooltip } from 'src/components/ui/Tooltip';
import Icon from 'src/components/Icon';
import trim from 'lodash/trim';
import classnames from 'src/util/classnames';
import useInterpolatedText from './utils/useInterpolatedText';

function StaticMarkdownBlurb(props) {
  const { i18n } = useLingui();
  const {
    schema: { id, content, title = '' },
    uiSchema: { 'ui:tooltipText': tooltipText = '', classNames, 'ui:classNames': uiCN, ':classNames': CN, 'ui:cellClassName': uiCCN },
    registry,
    fieldPathId: { path: dataPath } = {},
  } = props;
  const formContext = registry?.formContext;

  const tooltipRef = useRef(null);
  const rootFormData = useSideChannelSubscription(formContext?.sideChannel, 0);
  const { currentEntity } = useContext(UWEFormContext) ?? {};
  const interpolationBindings = useMemo(() => ({ currentEntity }), [currentEntity]);
  const evaluatedTooltipText = useInterpolatedText(tooltipText, rootFormData, dataPath, formContext, interpolationBindings);
  const evaluatedTitle = useInterpolatedText(title, rootFormData, dataPath, formContext, interpolationBindings);
  const evalatedContent = useInterpolatedText(content, rootFormData, dataPath, formContext, interpolationBindings);
  const parsedContent = renderTemplate(evalatedContent, { value: props.formData }, i18n.locale);

  return (
    <div id={id} className={classnames(classNames, uiCN, CN, uiCCN, 'static-markdown-blurb-container flex items-center gap-2')}>
      <div>
        {trim(title) && <Label className="control-label">{evaluatedTitle}</Label>}
        <Markdown>{parsedContent}</Markdown>
      </div>
      {evaluatedTooltipText && (
        <p className="flex items-center">
          <span ref={tooltipRef} className="cursor-help inline-flex items-center ">
            <Icon icon="Info" size={14} />
          </span>
          <UncontrolledTooltip target={tooltipRef}>{evaluatedTooltipText}</UncontrolledTooltip>
        </p>
      )}
    </div>
  );
}

export default StaticMarkdownBlurb;
